import { render } from "./AddApiManageView.vue?vue&type=template&id=050d075e&scoped=true"
import script from "./AddApiManageView.vue?vue&type=script&lang=js"
export * from "./AddApiManageView.vue?vue&type=script&lang=js"

import "./AddApiManageView.vue?vue&type=style&index=0&id=050d075e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050d075e"]])

export default __exports__